module.exports = __webpack_public_path__ + "img/Ficha_Santander.a7d185c9.jpg";